module.exports = __webpack_public_path__ + "static/dreamcorps-c4a42086c01ccdd38156d1d5c1a26d82.png";